import React, { useState, useEffect, useRef } from "react";
import { FaCaretDown  } from "react-icons/fa6";
import "./Dropdown.scss";
export type viewType = "verticale" | "horizontal";
export type mode = "light" | "dark";


export interface Props {
  mainClassName?: string;
  dropContentClass?: string;
  dropClassName?: string;
  children?: any;
  mainId?: string;
  dropId?: string;
  dropdownLabel?: string;
  data?: any;
  listButtonClick?: () => void;
  listInBtn?: boolean;
  placeHolder?: string;
  view?: viewType;
  dropdownMode?: mode;
  mainStyle?: React.CSSProperties;
  dropStyle?: React.CSSProperties;
  listStyle?: React.CSSProperties;
  listInBtnStyle?: React.CSSProperties;
  dropContentStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
}

const Dropdown = ({
  mainClassName,
  children,
  mainId,
  dropdownLabel,
  dropClassName,
  dropId,
  dropContentClass,
  data,
  listButtonClick,
  listInBtn = false,
  view = "verticale",
  placeHolder = "Select Value...",
  dropdownMode = "light",
  mainStyle,
  dropStyle,
  listStyle,
  listInBtnStyle,
  dropContentStyle,
  labelStyle,
}: Props) => {
  const ref = useRef<any>(null);
  const butref = useRef<any>(null);
  const dropref = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const [value, setVal] = useState();

  const handleToggle = () => {
    setOpen(!open);
  };
  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };
  const clickedItem = (value: any) => {
    setVal(value);
    setOpen(false);
    butref?.current?.focus();
  };
  useEffect(() => {
       
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        setOpen(false);
        butref?.current?.focus();
      }
    });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);
  return (
    <div
      className={`mfg-dropdown-wrapper${
        mainClassName ? " " + mainClassName : ""
      } ${view}${dropdownMode ? ' '+dropdownMode :''}`}
      id={mainId}
      ref={ref}
      style={mainStyle && mainStyle}
    >
      {dropdownLabel && <label  style={labelStyle && labelStyle} htmlFor={dropId}>{dropdownLabel}</label>}
      <div className="dropdownText">
        <button
          className={`dropDown${
            dropClassName ? " " + dropClassName : ""
          }`}
          onClick={handleToggle}
          aria-expanded={open ? "true" : "false"}
          ref={butref}
          style={dropStyle && dropStyle}
        >
          {value ? value : placeHolder}
          {value ? (
            <button
              onClick={() => clickedItem("")}
              className="dropicon"
              style={listInBtnStyle && listInBtnStyle}
            >
              X
            </button>
          ) : (
            <button style={listInBtnStyle && listInBtnStyle} onClick={handleToggle} className="dropicon" tabIndex={-1}>
            <FaCaretDown />
          </button> 
          )}
        </button>
        
        {(children || data) && open && (
          <div
            className={`dropContent${dropContentClass ? " " + dropContentClass : ""
              }`}
            ref={dropref}
            aria-labelledby={mainId}
            style={dropContentStyle && dropContentStyle}
          >
            {children}
            {data ? (
              <ul role="listbox" aria-activedescendant={ value }>
                {data.map((dataValue: any, index: number) => {
                  return (
                    <li
                      key={dataValue - index}
                      id={`${dataValue
                        .split(" ")
                        .join("")
                        .substring(0, 8)}-${index}`}
                      role="option"
                      style={listStyle && listStyle}
                    >
                      {listInBtn ? (
                        <button
                          onClick={() => {
                            listButtonClick?.();
                            handleToggle();
                            clickedItem(dataValue);
                          }}
                          style={listInBtnStyle && listInBtnStyle}
                        >
                          {dataValue}
                        </button>
                      ) : dataValue
                      }
                    </li>
                  );
                })}
              </ul>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
